export const instagramHandle = "himcream.naturals";
export const instagramUrl = "https://www.instagram.com/himcream.naturals/";
export const instagramReelsUrl = "https://www.instagram.com/himcream.naturals/reels/";

export const socialReels = [
  {
    id: "reel-1",
    number: 1,
    code: "DV1EMHtEj9D",
    url: "https://www.instagram.com/reel/DV1EMHtEj9D/",
    embedUrl: "https://www.instagram.com/reel/DV1EMHtEj9D/embed/",
    title: "HimCream Naturals • Fresh Ice Cream Churning",
    tag: "#1 Official Reel",
  },
  {
    id: "reel-2",
    number: 2,
    code: "DWWUevIkoW3",
    url: "https://www.instagram.com/reel/DWWUevIkoW3/",
    embedUrl: "https://www.instagram.com/reel/DWWUevIkoW3/embed/",
    title: "HimCream Naturals • Real Fruit Special",
    tag: "#2 Official Reel",
  },
  {
    id: "reel-3",
    number: 3,
    code: "DWjeC7gEpVv",
    url: "https://www.instagram.com/reel/DWjeC7gEpVv/",
    embedUrl: "https://www.instagram.com/reel/DWjeC7gEpVv/embed/",
    title: "HimCream Naturals • Signature Udaipur Scoop",
    tag: "#3 Official Reel",
  },
  {
    id: "reel-4",
    number: 4,
    code: "DWgje8tiLzu",
    url: "https://www.instagram.com/reel/DWgje8tiLzu/",
    embedUrl: "https://www.instagram.com/reel/DWgje8tiLzu/embed/",
    title: "HimCream Naturals • Thick Shakes & Desserts",
    tag: "#4 Official Reel",
  },
  {
    id: "reel-5",
    number: 5,
    code: "DXRBsQoEflf",
    url: "https://www.instagram.com/reel/DXRBsQoEflf/",
    embedUrl: "https://www.instagram.com/reel/DXRBsQoEflf/embed/",
    title: "HimCream Naturals • Fresh Churns in Store",
    tag: "#5 Official Reel",
  },
  {
    id: "reel-6",
    number: 6,
    code: "DXy4h4hI6j-",
    url: "https://www.instagram.com/reel/DXy4h4hI6j-/",
    embedUrl: "https://www.instagram.com/reel/DXy4h4hI6j-/embed/",
    title: "HimCream Naturals • Udaipur Foodies Choice",
    tag: "#6 Official Reel",
  },
];

// Fallback compatibility alias
export const socialPosts = socialReels.map((r) => ({
  id: r.id,
  type: "reel",
  title: r.title,
  caption: `Watch official HimCream Naturals Reel #${r.number} from Udaipur store!`,
  image: `https://images.unsplash.com/photo-1560008581-09826d1de69e?w=800&auto=format&fit=crop&q=85`,
  url: r.url,
  embedUrl: r.embedUrl,
  tag: r.tag,
  likes: "1.5k+",
  comments: "50+",
}));
